'use strict';

import $ from 'jquery';

export default class Form {
	constructor() {
		if($('.input--date').length) {
			const fp = flatpickr('.input--date', {
				altInput: true,
				altFormat: "F j, Y",
				dateFormat: "Y-m-d",
			});
		}
		
		$(`input[type='submit']`).map((i, ele) => {
			$(ele).wrap(`<div class="submit-wrapper"></div>`);
		});

		$('form').not('.nav__menu-search-form, #resource-form, #industry-form').map((i, ele) => {
			$(ele).submit(function (e) {
				setTimeout(function () {
					if (!$('.input-validation-error').length) {
						$("input[type='submit']", $(ele)).parent().addClass('disabled');
						$("input[type='submit']", $(ele)).addClass('disabled');
						$("input[type='submit']", $(ele)).val($("input[type='submit']", $(ele)).data('loading-text'));
					}
				}, 250);
				// if ($(this).valid()) {
				// 	$("input[type='submit']", $(ele)).parent().addClass('disabled');
				// 	$("input[type='submit']", $(ele)).addClass('disabled');
				// 	$("input[type='submit']", $(ele)).val($("input[type='submit']", $(ele)).data('loading-text'));
				// }
			});
		});

		if($('.checkbox-with-tooltip').length){
			$('.checkbox-with-tooltip').map((i, ele) => {
				$('.checkbox-tooltip-toggle', $(ele)).on('click', (e) => {
					e.preventDefault();
	
					if(!$('.checkbox__tooltip-panel', $(ele)).hasClass('active')) {
						$('.checkbox__tooltip-panel', $(ele)).addClass('active');
					}
				});

				$('.checkbox__tooltip-panel .panel-close', $(ele)).on('click', (e) => {
					if($('.checkbox__tooltip-panel', $(ele)).hasClass('active')) {
						$('.checkbox__tooltip-panel', $(ele)).removeClass('active');
					}
				});
	
				$('.checkbox__tooltip-panel', $(ele)).on('click', (e) => {
					if($('.checkbox__tooltip-panel', $(ele)).hasClass('active')) {
						$('.checkbox__tooltip-panel', $(ele)).removeClass('active');
					}
				});
	
				$('.checkbox__tooltip-panel > div', $(ele)).on('click', (e) => {
					e.stopPropagation();
				});
			});
		}
	}
}
